<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-sm-8 align-self-center">
                <div class="card mt-5 shadow" style="max-width: 500px; margin: 0 auto">
                    <div class="text-center">
                        <img class="mt-4" src="/ventisquero_smallLogo_dark.png" width="80%" alt="Viña Ventisquero">

                        <h3 style="color: #495057;" class="card-title mt-4">Iniciar Sesión</h3>
                    </div>
                    <div class="card-body text-center" style="background-color: #fafbfd">
                        <button class="btn btn-primary btn-block" :disabled="isLoading" @click="loginWithMicrosoft">
                            <i class="fa fa-windows mr-2"></i>
                            {{ isLoading ? 'Cargando...' : 'Iniciar sesión con Microsoft' }}
                        </button>
                    </div>
                    <!--
                <div class="card-body" style="background-color: #fafbfd">
                    <form action="" method="post">
                        <div class="form-group mt-2">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <i class="fa fa-user"></i>
                                    </span>    
                                </div>
                                <input placeholder="Email" type="email" class="form-control" required="required" v-model="email">
                            </div>
                         </div>
                        <div class="form-group">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <i class="fa fa-lock"></i>
                                    </span>  
                                </div>
                                <input placeholder="Contraseña" type="password" class="form-control" required="required" v-model="password" />
                            </div>
                        </div>
                        <br />
                        <button @click.prevent="signIn" class="btn btn-success btn-block">Enviar</button>
                    </form>
                </div>-->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Get } from '../helper/axios'
import toastr from 'toastr'

export default {
    data() {
        return {
            Get,
            isLoading: false,
            apiUrl: this.$store.getters.apiUrl + 'auth/login'
        }
    },
    created() {
        this.$store.commit('logout')
    },    
    mounted() {
        window.addEventListener('message', this.handleMessage);
    },
    beforeDestroy() {
        window.removeEventListener('message', this.handleMessage);
    },
    methods: {
        async loginWithMicrosoft() {
            try {
                this.$store.commit('setLoading', true);
                this.isLoading = true;
                this.Get(this.apiUrl + "/microsoft-auth-url", (res) => {
                    this.isLoading = false;
                    var response = res.data

                    if (response?.statusCode !== 200 || !response.data) {
                        toastr.error('Error al configurar la autenticación');
                        return;
                    }

                    const width = 500;
                    const height = 600;
                    const left = (screen.width - width) / 2;
                    const top = (screen.height - height) / 2;

                    window.open(
                        response.data,
                        'Microsoft Login',
                        `width=${width},height=${height},top=${top},left=${left}`
                    );
                });

            } catch (e) {
                console.error(e);
                toastr.error('Error al iniciar sesión');
            } finally {
                this.$store.commit('setLoading', false);
            }
        },

        handleMessage(event) {
            if (event.origin !== window.location.origin) return;

            if (event.data?.type === 'MICROSOFT_LOGIN_SUCCESS') {

                var data = event.data.data;
                this.$store.commit('setAuth', {
                    accessToken: data.accessToken,
                    user: {
                        id: data.userId,
                        email: data.userEmail,
                        name: data.userName,
                        fullName: data.userFullName,
                        roles: data.userRole
                    }
                })

                toastr.success('Login exitoso');

                this.redirect();
            }
        },

        redirect() {
            this.$router.push('/');
        }
    }
}

/*
export default {
    data() {
        return {
            email: '',
            password: '',
            Post,
            apiUrl: this.$store.getters.apiUrl + 'auth/login'
        }
    },
    created() {
        this.$store.commit('setToken', '');
    },
    methods: {
        signIn() {
            if (this.email && this.password) {
                this.$store.commit('setLoading', true);
                this.Post(this.apiUrl, { UserName: this.email, Password: this.password }, (res) => {
                    this.$store.commit('setToken', res.data);
                    this.$store.commit('setLoading', false)
                    this.$router.push('/');
                })
            } else {
                window.toastr.warning('Debe ingresar su email y contraseña');
            }
        }
    }
}
*/
</script>